import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>Hi, my name is Anna</h1>
            </header>
            <div className="content">
                <p>Come join me to build and maintain that physique<br />
                you always wanted, or just join for the laughs!</p>
                <ul className="actions">
                    <li><a href="#one" className="button next scrolly">Find out more</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner
